module.exports = __webpack_public_path__ + "img/info@2x.03aee536.png";